/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Problem_Solving14Inputs */

const en_job_form_enum_problem_solving14 = /** @type {(inputs: Job_Form_Enum_Problem_Solving14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem Solving`)
};

const de_job_form_enum_problem_solving14 = /** @type {(inputs: Job_Form_Enum_Problem_Solving14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problemlösungsfähigkeit`)
};

/**
* | output |
* | --- |
* | "Problem Solving" |
*
* @param {Job_Form_Enum_Problem_Solving14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_problem_solving14 = /** @type {((inputs?: Job_Form_Enum_Problem_Solving14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Problem_Solving14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_problem_solving14(inputs)
	return en_job_form_enum_problem_solving14(inputs)
});
export { job_form_enum_problem_solving14 as "job_form_enum_PROBLEM_SOLVING" }